import { render, staticRenderFns } from "./tbqd.vue?vue&type=template&id=7e544bf8&scoped=true"
import script from "./tbqd.vue?vue&type=script&lang=js"
export * from "./tbqd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e544bf8",
  null
  
)

export default component.exports